import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "__classrooms-student-mfe" }
const _hoisted_2 = { "data-bs-theme": "light" }
const _hoisted_3 = { key: 1 }

import { onBeforeMount, computed } from 'vue'
import BsToastQueue from '@/components/BsToastQueue'
import BsToastQueueStore from '@/components/BsToastQueueStore'
import WelcomeMessage from '@/components/WelcomeMessage'
import CoachingSession from '@/components/CoachingSession'
import TitleBar from '@/components/TitleBar'
import ClassroomStudentService, { ClassroomEventParams } from '@/components/ClassroomStudentService'
import CoachingSessionStore from '@/components/CoachingSessionStore'
import SessionRegistry from '@/components/SessionRegistry'
import SessionRegistryStore from '@/components/SessionRegistryStore'
import { InitConfiguration } from '@/config/config'
import locales from './ClassroomStudentApp.locales.en.json'


export default /*#__PURE__*/_defineComponent({
  __name: 'ClassroomStudentApp',
  props: {
    year: {},
    period: {},
    token: {},
    attendee: {},
    productLabel: {},
    productValue: {},
    jurisdictionLabel: {},
    jurisdictionValue: {},
    enrollmentId: {},
    askQuestionUrl: {},
    schoolId: {}
  },
  setup(__props: any) {

const props = __props

const validClassroomEventParams = computed(() => {
  const params = {
    year: props.year,
    period: props.period,
    token: props.token,
    attendee: props.attendee,
    productId: props.productValue,
    jurisdictionId: props.jurisdictionValue,
    enrollmentId: props.enrollmentId,
    schoolId: props.schoolId
  }
  return checkIsValidClassroomEventParams(params) ? params : undefined
})

function checkIsValidClassroomEventParams(value: typeof props): value is ClassroomEventParams {
  return Boolean(value.attendee && value.token)
}

onBeforeMount(InitConfiguration)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BsToastQueueStore), null, {
        default: _withCtx(() => [
          (validClassroomEventParams.value)
            ? (_openBlock(), _createBlock(_unref(ClassroomStudentService), {
                key: 0,
                params: validClassroomEventParams.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(SessionRegistryStore), null, {
                    default: _withCtx(({ store }) => [
                      _createVNode(_unref(TitleBar), {
                        "is-lsat": store.sessionState.isLSAT,
                        "ask-question-url": _ctx.askQuestionUrl
                      }, null, 8, ["is-lsat", "ask-question-url"]),
                      (store.sessionState.attendeeIsRegistered)
                        ? (_openBlock(), _createBlock(_unref(CoachingSessionStore), { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(CoachingSession), {
                                "is-ebar": store.sessionState.isEBar,
                                sessions: store.sessionState.sessions
                              }, null, 8, ["is-ebar", "sessions"])
                            ]),
                            _: 2
                          }, 1024))
                        : (!store.sessionState.isLSAT)
                          ? (_openBlock(), _createBlock(_unref(WelcomeMessage), { key: 1 }))
                          : _createCommentVNode("", true),
                      _createVNode(_unref(SessionRegistry))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["params"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(locales).message_must_be_logged_in), 1)),
          _createVNode(_unref(BsToastQueue))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})